import type { ReactNode } from 'react';

import { Divider, Stack, Typography } from '@mui/material';

export type GalleryStatistic = {
	label: string;
	value: ReactNode;
};

type GalleryStatisticsProps = {
	items: GalleryStatistic[];
	minWidth?: number;
};

/** Shared compact statistics row for gallery headers. */
export default function GalleryStatistics({ items, minWidth = 88 }: GalleryStatisticsProps) {
	return (
		<Stack direction="row" divider={<Divider orientation="vertical" flexItem />} spacing={0}>
			{items.map((item) => (
				<Stack key={item.label} spacing={0.25} sx={{ minWidth, px: { xs: 1, sm: 2 } }}>
					<Typography
						variant="h6"
						color="primary.main"
						fontWeight={600}
						lineHeight={1.1}
						noWrap
						sx={{ maxWidth: { xs: 104, sm: 168 }, overflow: 'hidden', textOverflow: 'ellipsis' }}
					>
						{item.value}
					</Typography>
					<Typography variant="caption" color="text.secondary" noWrap>
						{item.label}
					</Typography>
				</Stack>
			))}
		</Stack>
	);
}
